import { render } from "./HorizontalCard.vue?vue&type=template&id=54ef73ae&scoped=true&lang=true"
import script from "./HorizontalCard.vue?vue&type=script&lang=js"
export * from "./HorizontalCard.vue?vue&type=script&lang=js"

import "./HorizontalCard.css?vue&type=style&index=0&id=54ef73ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ef73ae"]])

export default __exports__